module.exports = __webpack_public_path__ + "static/media/pp_warning.b3defadb.svg";